import {
  FETCH_BV_QUESTION_ANSWER_REQUEST,
  FETCH_BV_QUESTION_ANSWER_SUCCESS,
  FETCH_BV_QUESTION_ANSWER_FAILURE
} from '../../actionTypes/bazaarVoiceQuestionAnswerActionTypes'

const initialState = {
  data: {},
  meta: {}
}

const buildRequestState = (oldState, payload) => {
  const { partNumber } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const oldProductQuestions = oldData.productQuestions || {}
  const oldProductPaginatedQuestions = oldData.productPaginatedQuestions || {}

  const newState = {
    ...oldState,
    data: {
      ...oldData,
      productQuestions: {
        ...oldProductQuestions,
        [partNumber]: oldProductQuestions[partNumber] || undefined
      },
      productPaginatedQuestions: {
        ...oldProductPaginatedQuestions,
        [partNumber]: oldProductPaginatedQuestions[partNumber] || undefined
      },
      cache: {
        ...oldData.cache
      },
      searchTerm: oldData.searchTerm,
      stats: oldData.stats
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: false
      }
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { partNumber, newData } = payload
  const { cache, questions, paginatedQuestions, searchTerm, stats } = newData
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const oldProductQuestions = oldData.productQuestions || {}
  const oldProductPaginatedQuestions = oldData.productPaginatedQuestions || {}
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      productQuestions: {
        ...oldProductQuestions,
        [partNumber]: [...questions]
      },
      productPaginatedQuestions: {
        ...oldProductPaginatedQuestions,
        [partNumber]:
          stats.attributes.Offset === 0
            ? [...paginatedQuestions]
            : [...oldProductPaginatedQuestions[partNumber], ...paginatedQuestions]
      },
      cache: {
        ...oldData.cache,
        ...cache
      },
      searchTerm,
      stats
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: true
      }
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { partNumber, errorDetail } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const oldProductQuestions = oldData.productQuestions || {}
  const oldProductPaginatedQuestions = oldData.productPaginatedQuestions || {}
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      productQuestions: {
        ...oldProductQuestions,
        [partNumber]: oldProductQuestions[partNumber] || undefined
      },
      productPaginatedQuestions: {
        ...oldProductPaginatedQuestions,
        [partNumber]: oldProductPaginatedQuestions[partNumber] || undefined
      },
      cache: {
        ...oldData.cache
      },
      searchTerm: oldData.searchTerm,
      stats: oldData.stats
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail,
        requestDone: true
      }
    }
  }
  return newState
}

const bazaarVoiceQuestionAnswerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_BV_QUESTION_ANSWER_REQUEST:
      return buildRequestState(state, payload)
    case FETCH_BV_QUESTION_ANSWER_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_BV_QUESTION_ANSWER_FAILURE:
      return buildFailureState(state, payload)
    default:
      return state
  }
}

export { initialState, bazaarVoiceQuestionAnswerReducer }
